module.exports = __webpack_public_path__ + "public/img/06.fae2104a.jpg";